import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import Button from '~/components/TrailDS/Button.vue'

export default <RegisteredComponent>{
  name: 'Trail Button',
  tag: 'trail-ds-button',
  component: markRaw(Button),
  inputs: [
    {
      name: 'variant',
      type: 'string',
      defaultValue: 'primary',
      enum: ['primary', 'secondary', 'tertiary'],
    },
    {
      name: 'size',
      type: 'string',
      defaultValue: 'normal',
      enum: ['small', 'normal'],
    },
    {
      name: 'destructive',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Text',
        options: { text: 'Button' },
      },
    },
  ],
}
